import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const initialState = {
  buildings: [],
  buildingById: null,
  buildingsLoading: false,
  buildingsError: '',
  buildingsGraph: [],
  buildingsPage: 1,
  buildingsTotalPages: 1,
  allBuildings: [],
  allBuildingsLoading: false,
  allBuildingsError: '',
};

const buildingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case AC.GET_BUILDINGS_REQUEST:
    case AC.GET_BUILDING_DETAILS_REQUEST:
    case AC.ADD_BUILDING_REQUEST:
    case AC.EDIT_BUILDING_REQUEST:
    case AC.DELETE_BUILDING_REQUEST:
    case AC.GET_BUILDINGS_GRAPH_REQUEST:
      return updateObject(state, {buildingsLoading: true, buildingsError: ''});
    case AC.GET_BUILDINGS_SUCCEED:
      return updateObject(state, {
        buildings: action.payload,
        buildingsPage: action.page,
        buildingsTotalPages: action.totalPages,
        buildingsLoading: false,
      });
    case AC.GET_BUILDING_DETAILS_SUCCEED:
    case AC.EDIT_BUILDING_SUCCEED:
      return updateObject(state, {
        buildingById: action.payload,
        buildingsLoading: false,
      });
    case AC.GET_BUILDINGS_GRAPH_SUCCEED:
      return updateObject(state, {
        buildingsGraph: action.payload,
        buildingsLoading: false,
      });
    case AC.GET_ALL_BUILDINGS_REQUEST:
      return updateObject(state, {allBuildingsLoading: true, allBuildingsError: ''});

    case AC.GET_ALL_BUILDINGS_SUCCEED:
      return updateObject(state, {
        allBuildings: action.payload,
        allBuildingsLoading: false,
      });

    case AC.GET_ALL_BUILDINGS_FAILED:
      return updateObject(state, {
        allBuildingsError: action.payload,
        allBuildingsLoading: false,
      });
    case AC.GET_BUILDINGS_FAILED:
    case AC.GET_BUILDING_DETAILS_FAILED:
    case AC.ADD_BUILDING_FAILED:
    case AC.EDIT_BUILDING_FAILED:
    case AC.DELETE_BUILDING_FAILED:
    case AC.GET_BUILDINGS_GRAPH_FAILED:
      return updateObject(state, {
        buildingsError: action.payload,
        buildingsLoading: false,
      });
    default:
      return state;
  }
};

export default buildingsReducer;
